import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';


declare interface ICountryItem{
  id: number,
  pid: number,
  name: string,
  level: number,
  icon: string,
  dialling_code: string
}

declare type ICountryList  = ICountryItem[]
declare interface IInitialState {
  other: any,
  value: ICountryList
}

const initialState: IInitialState = {
  other: '',
  value: [],
};

export const slice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCountry: (state: any, action) => {
      state.value = action.payload;
    }
  },
});

export const { setCountry } = slice.actions;

export const countryList = (state: RootState) => {
  return state.country.value;
};

export default slice.reducer;